import $ from 'jquery';
import 'slick-carousel';

const sliderReviewProduct = () => {
    const init = () => {
        exec();
    };

    const exec = () => {
        const $slider = $('.mi-review');

        if (!$slider.length) return;

        $slider.slick({
            arrows: true,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: `
                <button type="button" class="slick-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18.9998 12H5.99985M10.9998 6L5.70696 11.2929C5.31643 11.6834 5.31643 12.3166 5.70696 12.7071L10.9998 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
                </button>
            `,

            nextArrow: `
                <button type="button" class="slick-next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M5 12H18M13 6L18.2929 11.2929C18.6834 11.6834 18.6834 12.3166 18.2929 12.7071L13 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
                </button>
            `,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    }
                }
            ]
        });
    };

    init();
};

try {
    sliderReviewProduct();
} catch (e) {
    console.error(e);
}